export const ParticipantFormFieldIds = {
  Title: 'Title',
  Name: 'Name',
  Surname: 'Surname',
  Birthdate: 'Birthdate',
  StreetName: 'StreetName',
  StreetNumber: 'StreetNumber',
  StreetNumberAdditional: 'StreetNumberAdditional',
  PostalCode: 'PostalCode',
  CityName: 'CityName',
  Country: 'Country',
  Email: 'Email',
  MobilePhoneNumber: 'MobilePhoneNumber',
  EmergencyPhoneNumber: 'EmergencyPhoneNumber',
} as const
